"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.Alert = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
require("./Alert.css");
var CloseIcon_1 = __importDefault(require("mdi-react/CloseIcon"));
var IconSuccess_1 = __importDefault(require("../IconSuccess"));
var IconInfo_1 = __importDefault(require("../IconInfo"));
var IconWarning_1 = __importDefault(require("../IconWarning"));
var Button_1 = require("../Button");
var Alert = function (_a) {
    var children = _a.children, className = _a.className, type = _a.type, closeType = _a.closeType, onClose = _a.onClose, closeButtonText = _a.closeButtonText, restProps = __rest(_a, ["children", "className", "type", "closeType", "onClose", "closeButtonText"]);
    var classes = (0, classnames_1["default"])('vs-alert-d', "vs-".concat(type, "-alert"), className);
    var iconMap = {
        success: react_1["default"].createElement(IconSuccess_1["default"], { className: "vs-alert-icon" }),
        info: react_1["default"].createElement(IconInfo_1["default"], { className: "vs-alert-icon" }),
        warning: react_1["default"].createElement(IconWarning_1["default"], { className: "vs-alert-icon" })
    };
    var closeButtonMap = {
        icon: (react_1["default"].createElement(CloseIcon_1["default"], { className: "vs-alert-close-icon", onClick: function () { return onClose(); } })),
        button: (react_1["default"].createElement(Button_1.Button, { type: "outline-secondary", className: 'vs-alert-close-button', onClick: function () { return onClose(); } }, closeButtonText))
    };
    return (react_1["default"].createElement("div", __assign({}, restProps, { className: classes }),
        react_1["default"].createElement("div", { className: "vs-alert-icon-container" }, iconMap[type] || iconMap.info),
        react_1["default"].createElement("div", { className: "vs-alert-content" }, children),
        react_1["default"].createElement("div", { className: "vs-alert-close-container" }, closeButtonMap[closeType])));
};
exports.Alert = Alert;
